import { DateRangeSchema, sortOrderType } from '@/utils';
import { z } from 'zod';
import { NAME_MAX_LENGTH } from '../utils';
import { AccountingTypeModel } from './accounting-type';

export const AccountTitleBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  code: z.number().int().min(1),
  name: z.string().min(1),
  accountingId: z.string().uuid(),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  sortOrder: sortOrderType.max(9999),
});

export const AccountTitlesModel = AccountTitleBaseModel.extend({
  accountingType: AccountingTypeModel,
}).array();

export const AccountTitleFormSchema = AccountTitleBaseModel.pick({
  code: true,
  accountingId: true,
  sortOrder: true,
}).extend({
  name: AccountTitleBaseModel.shape.name.max(NAME_MAX_LENGTH),
  period: DateRangeSchema.nullish(),
});
